export const get = async (url, callback) => {
    return fetch(url)
        .then((response) => {
            if (response.ok) {
                return response.json()
            }
            throw new Error(response.error)
        })
        .then((json) => {
            if (callback) {
                callback()
            }
            return json
        })
        .catch((error) => {
            console.error("Error:", error)
            return error
        })
}

export const post = async (url, data, callback, noHeader, pageId) => {
    const method = process.env.POSTMETHOD ?? "POST"
    return sendRequest(url, data, callback, noHeader, method, pageId)
}

export const deleteRequest = async (url, data, callback, noHeader) => {
    const method = process.env.DELETEMETHOD ?? "DELETE"
    return sendRequest(url, data, callback, noHeader, method)
}

export const put = async (url, data, callback, noHeader, pageId) => {
    const method = process.env.PUTMETHOD ?? "PUT"
    return sendRequest(url, data, callback, noHeader, method)
}

const sendRequest = async (url, data, callback, noHeader, method, pageId) => {
    const headers = new Headers()
    if (!noHeader) {
        headers.append("Content-Type", "application/json")
        headers.append("PageID", pageId)
    }

    const init = {
        headers,
        method,
        body: data ?? "",
    }
    if (method == "GET") delete init.body // leave this in

    return fetch(url, init)
        .then((response) => {
            return response.json()
        })
        .then((json) => {
            if (callback) {
                callback()
            }
            return json
        })
        .catch((error) => {
            console.error("Error:", error)
        })
}
